import React, { FC } from "react";
import { SystemMessageSearchHeaderWrapper } from "./SystemMessageSearchHeader.style";
import {
  InformationBox,
  MuiButtonPrimary,
  MuiGrid,
} from "../../../../components";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { searchSystemMessageSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS } from "../../../../helpers/constants";

interface MessageSearchHeaderProps {
  pageId: string;
  onAddMessage: () => void;
}

export const MessageSearchHeader: FC<MessageSearchHeaderProps> = ({
  pageId,
  onAddMessage,
}) => {
  const { pageTitle, fetchLabel } = useSiteCore();
  return (
    <SystemMessageSearchHeaderWrapper>
      <MuiGrid container data-testid="message-header">
        <MuiGrid size={{ sm: 6, xs: 12 }} className="header-left">
          <InformationBox title={pageTitle} />
        </MuiGrid>
        <PermissionWrapper
          permission={MODULE_PERMISSIONS.CREATE_SYSTEM_MESSAGES}
        >
          <MuiGrid size={{ sm: 6, xs: 12 }} className="header-right">
            <MuiButtonPrimary
              onClick={onAddMessage}
              className="header-right-button"
              id={`${pageId}-new-button`}
              data-testid={`${pageId}-new-button`}
            >
              {fetchLabel(
                searchSystemMessageSiteCoreKeys.headerKey,
                searchSystemMessageSiteCoreKeys.createSystemMessagesButton,
              )}
            </MuiButtonPrimary>
          </MuiGrid>
        </PermissionWrapper>
      </MuiGrid>
    </SystemMessageSearchHeaderWrapper>
  );
};
